import { Injectable } from "@angular/core";
import { StorageService } from "./storage-Service";
import { HttpheadersModel } from "../models/httpHeaders";
import { AccessControlResponse } from "../models/accessControlResponse";
import * as cryptoJS from "crypto-js";

@Injectable()
export class HttpHeaderService {
  httpheaders = new HttpheadersModel();
  token: string;
  constructor(private storage: StorageService) {}

  setHeaders() {
    this.token = this.storage.getAccessToken();

    this.httpheaders.Nonce = "UniCollect";
    this.httpheaders.accessToken = this.token;

    this.httpheaders.Rexpay_checkout = "true";
    this.httpheaders.deviceInformation = {
      httpBrowserLanguage: window.navigator.language,
      httpBrowserJavaEnabled: window.navigator.javaEnabled().toString(),
      httpBrowserJavaScriptEnabled: "true",
      httpBrowserColorDepth: window.screen.colorDepth.toString(),
      httpBrowserScreenHeight: window.screen.height.toString(),
      httpBrowserScreenWidth: window.screen.width.toString(),
      userAgentBrowserValue: window.navigator.userAgent,
      httpBrowserTimeDifference: "",
      httpBrowserTZ: new Date().getTimezoneOffset().toString(),
      httpBrowserAcceptHeader:
        "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8",
    };
    this.httpheaders.httpBrowserJavaEnabled = window.navigator
      .javaEnabled()
      .toString();
    this.httpheaders.httpBrowserJavaScriptEnabled = "true";
    this.httpheaders.httpBrowserColorDepth =
      window.screen.colorDepth.toString();
    this.httpheaders.httpBrowserLanguage = window.navigator.language;
    this.httpheaders.httpBrowserScreenHeight = window.screen.height.toString();
    this.httpheaders.httpBrowserScreenWidth = window.screen.width.toString();
    this.httpheaders.userAgentBrowserValue = window.navigator.userAgent;
    this.httpheaders.httpBrowserTimeDifference = "";
    this.httpheaders.httpBrowserTZ = new Date().getTimezoneOffset().toString();
    this.httpheaders.httpBrowserAcceptHeader =
      "text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8";
  }

  encodeUrl(url) {
    let encodedUrl = encodeURIComponent(url);
    return encodedUrl;
  }

  setSignature(httpMethod: string, url) {
    // this.setHeaders();

    this.httpheaders.signature = cryptoJS.SHA512(
      this.httpheaders.accessToken +
        "&&" +
        this.httpheaders.accessKey +
        "&&" +
        this.httpheaders.Timestamp +
        "&&" +
        this.httpheaders.Nonce +
        "&&" +
        httpMethod +
        "&&" +
        this.encodeUrl(url),
    );
    return this.httpheaders.signature;
  }
}
